const divLogin = {
  showError: 'Error in the request, if it persists, contact support',
  showErrorConnection: 'Connection error',
  showErrorManyRequests: 'Too many attempts in a row, try again in a moment',
  showErrorPassword: 'Incorrect username or password',

  noAccess: 'You do not have authorization, talk to your administrator'
};

export default divLogin;
